import { render, staticRenderFns } from "./AssignSpecialist.vue?vue&type=template&id=588b9907"
import script from "./AssignSpecialist.vue?vue&type=script&lang=js"
export * from "./AssignSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588b9907')) {
      api.createRecord('588b9907', component.options)
    } else {
      api.reload('588b9907', component.options)
    }
    module.hot.accept("./AssignSpecialist.vue?vue&type=template&id=588b9907", function () {
      api.rerender('588b9907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/AssignSpecialist.vue"
export default component.exports